<!--
 * @Author: zxf
 * @Date: 2022-07-20 18:18:58
 * @LastEditors: zxf
 * @LastEditTime: 2023-05-04 17:56:12
 * @Description: 维保用户查看
-->
<template>
  <el-form
    ref="fd"
    v-loading="loading"
    :inline="true"
    label-suffix="："
    :model="fd"
    label-position="right"
    label-width="150px"
    class="c-form u-pd-b-10"
  >
    <!-- 基本信息 -->
    <el-row
      class="c-form__row"
    >
      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        项目基础信息
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="重点单位"
          prop="zddwBz"
        >
          <span class="c-form__read">{{ fd.zddw === 'Y' ? '是' : '否' || '-' }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="签到要求"
          prop="qdyq"
        >
          <span class="c-form__read">{{ fd.qdyq === '0' ? 'GPS定位' : 'GPS定位+人脸识别' }}</span>
        </el-form-item>
      </el-col>
      <!-- <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="bgms"
          label="报告模式"
        >
          <span class="c-form__read">{{ fd.bgms === '0' ? '线上':'线下' || '-' }}</span>
        </el-form-item>
      </el-col> -->
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="企业名称"
          prop="wtdw"
        >
          <span class="c-form__read">{{ fd.wtdw || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="shxydm"
          label="统一社会信用代码"
        >
          <span class="c-form__read">{{ fd.shxydm || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="项目名称"
          prop="xmmc"
        >
          <span class="c-form__read">{{ fd.xmmc || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          label="所属区域"
          prop="areaMc"
        >
          <span class="c-form__read">{{ fd.areaMc || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="xmdz"
          label="项目地址"
        >
          <span class="c-form__read">{{ fd.xmdz || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="xfaqglr"
          label="消防安全管理人"
        >
          <span class="c-form__read">{{ fd.xfaqglr || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="sjhm"
          label="手机号码"
        >
          <span class="c-form__read">{{ fd.sjhm || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="wygldw"
          label="物业管理单位"
        >
          <span class="c-form__read">{{ fd.wygldw || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          prop="fsdwxx"
          label="附属单位信息"
        >
          <span class="c-form__read">{{ fd.fsdwxx || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="合同名称"
          prop="htmc"
        >
          <span class="c-form__read">{{ fd.htmc || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="合同编号"
          prop="htbh"
        >
          <span class="c-form__read">{{ fd.htbh || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="合同有效期"
          prop="htyxq"
        >
          <span class="c-form__read">{{ fd.htyxqQ || '-' | date("yyyy-MM-dd ") }}</span> 至 <span class="c-form__read">{{ fd.htyxqZ || '-' | date("yyyy-MM-dd ") }}</span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="12"
      >
        <el-form-item
          class="c-form__item"
          label="合同金额（元）"
          prop="htje"
        >
          <span class="c-form__read">{{ fd.htje || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col"
        :span="24"
      >
        <el-form-item
          class="c-form__item"
          label="合同文件"
          prop="htfjId"
        >
          <file-list
            v-model="fd.htfjId"
            disabled
          />
        </el-form-item>
      </el-col>
      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="xmgs"
          label="项目概况"
        >
          <textarea-read
            v-model="fd.xmgs"
            class="c-form__read u-line-20"
          />
        </el-form-item>
      </el-col>
      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        建筑信息
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="jzlbMc"
          label="建筑类别"
        >
          <span class="c-form__read">{{ fd.jzlbMc || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="zdxfsb"
          label="自动消防设备"
        >
          <span class="c-form__read">{{ fd.zdxfsb === 'Y' ? "有" : "否" || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="zzdmj"
          label="总占地面积（m²）"
        >
          <span class="c-form__read">{{ fd.zzdmj || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="zjzmj"
          label="总建筑面积（m²）"
        >
          <span class="c-form__read">{{ fd.zjzmj || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="jzlc"
          label="建筑层数"
        >
          <span class="c-form__read">{{ fd.jzlc || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="jzgd"
          label="建筑高度（m）"
        >
          <span class="c-form__read">{{ fd.jzgd || '-' }}</span>
        </el-form-item>
      </el-col>

      <el-col
        class="c-form__col c-form__part-title"
        :span="24"
      >
        维保信息
      </el-col>
      <!-- <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="gdptzdts"
          label="广东平台自动推送"
        >
          <span class="c-form__read">{{ fd.gdptzdts === 'Y' ? '是' : '否' || '-' }}</span>
        </el-form-item>
      </el-col> -->
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="xmfzrMc"
          label="项目负责人"
        >
          <span class="c-form__read">{{ fd.xmfzrMc || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col
        :span="12"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="jsfzrMc"
          label="技术负责人"
        >
          <span class="c-form__read">{{ fd.jsfzrMc || '-' }}</span>
        </el-form-item>
      </el-col>

      <el-col
        :span="24"
        class="c-form__col"
      >
        <el-form-item
          class="c-form__item"
          prop="wbnrList"
          label="维保内容"
        >
          <span
            v-for="(item,index) in fd.wbnrList"
            :key="`wbxmInfo-${index}`"
            class="c-form__read"
          >
            {{ index+1 }}、{{ item.wbnrMc }}{{ fd.wbnrList.length === index + 1 ?' ': '；' }}
          </span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { wbxmService } from './wbxm.service.js';

export default {
  name: 'ViewWbxmInfo',
  data () {
    return {
      loading: false, // 页面loading状态

      /* 项目信息 Start */
      fd: {
        zddwBz: null, // 重点单位
        qdyq: null, // 签到要求
        areaMc: null, // 所属区域
        wtdw: null, // 企业名称
        xmmc: null, // 项目名称
        xmdz: null, // 项目地址
        shxydm: null, // 统一社会信用代码【规则】
        xfaqglr: null, // 消防安全管理人
        sjhm: null, // 手机号码
        jzlbMc: null, // 建筑类别
        zdxfsb: null, // 自动消防设备
        zzdmj: null, // 总占地面积
        zjzmj: null, // 总建筑面积
        jzlc: null, // 建筑层数
        jzgd: null, // 建筑高度
        xmgs: null, // 项目概况
        bgms: null, // 报告模式
        xmfzrMc: null, // 项目负责人
        jsfzrMc: null, // 技术负责人
        wygldw: null, // 物业管理单位
        gdptzdts: null, // 广东平台自动推送
        fsdwxx: null, // 附属单位信息
        wbnrList: []

      }
      /* 项目信息 End */

    };
  },
  methods: {
    /**
     * @description: 初始化维保项目信息
     * @return {*}
     * @param {*} xmId 维保项目编码
     */
    initWbxmInfo (xmId) {
      this.loading = true;
      wbxmService.getWbxmInfo(xmId)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('初始化维保项目信息失败', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
  },
  created () {
    // 获取路由项目编码
    this.fd.xmId = this.$route.params.xmId;
    this.initWbxmInfo(this.fd.xmId);
  }

};
</script>

<style lang="scss">

.dev-pGroup__detail{
  padding: 8px 8px 8px 2px;
}

.dev-c-page__footer--div{
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
</style>
